// extracted by mini-css-extract-plugin
export default {"xs":"Text_xs__cApfH","s":"Text_s__jpsjf","m":"Text_m__pE-Ti","l":"Text_l__8-6mo","xl":"Text_xl__cQs4s","xxl":"Text_xxl__RGVyP"};